import { children, JSXElement } from "solid-js"
import styles from './st-menu.module.css';
import Dropdown from "../st-dropdown/st-dropdown";

export class STMenuProps {
    children: JSXElement;
    label!: string | JSXElement;
}

export default function Menu(props: STMenuProps) {
    const content = children(() => props.children)

    return <>
        <Dropdown>
            <Dropdown.Trigger class={styles["st-menu-label"]} role="button">
                <span style="margin-right: 5px">{props.label}</span>
                <i class="fas fa-caret-down"></i>
            </Dropdown.Trigger>
            <Dropdown.Content>
                <ul class={styles['st-menu']}>
                    {content()}
                </ul>
            </Dropdown.Content>
        </Dropdown>
    </>
}

Menu.defaultProps = new STMenuProps();

export class STMenuItemProps {
    children?: JSXElement;
    label!: string;
    value?: string;
    onClick?: (value: string) => void;
}

Menu.Item = (props: STMenuItemProps) => {
    const content = children(() => props.children)
    const value = props.value || props.label;

    const handleClick = () => {
        if (props.onClick) {
            props.onClick(value);
        }
    };

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
        }
    };

    return <li
        data-value={value}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        role="menuitem"
        tabIndex={0}
        class={styles['st-menu-item']}
    >
        <span>{props.label}</span>
        {content()}
    </li>
}
